import { TRANSPORT } from '../../service/enums.js';
import { removeUndefined } from '../../utils/objects.js';
import BaseField from './BaseField.js';
class ConstField extends BaseField {
    const;
    constructor(data) {
        super({ ...data, required: true, example: data.const });
        this.const = data.const;
        this.proto = {
            definition: [],
            comments: [],
            type: '',
        };
    }
    getExample(transport) {
        if (transport === TRANSPORT.GRPC) {
            return undefined;
        }
        return this.const;
    }
    toSchema(transport, options) {
        if (transport === TRANSPORT.GRPC) {
            return undefined;
        }
        return removeUndefined({
            ...super.toSchema(transport, options),
            enum: [this.const],
            default: this.const,
        });
    }
    fromJSON() {
        return this.const;
    }
}
export default ConstField;
//# sourceMappingURL=ConstField.js.map